import React, { useEffect } from "react";
import { useState } from "react";
import Footer from "../../../MyComponents/Footer";
import GuestNav from "../../../MyComponents/Navbars/GuestNav";
import Hero2 from "../../../MyComponents/Hero2";
import heroContent from "../HeroContent";
import leftimg from "../../../assets/AIpromptEngLeftImg.png";
import rightimg from "../../../assets/AIpromptEngRightImg.png";
import CourseTimeline from "../../../MyComponents/CourseTimeline";
import Benefits from "../../../MyComponents/Benefits";
import AIpromptEngBenefitsImg1 from "../../../assets/AIpromptEngBenefitsImg1.png";
import AIpromptEngBenefitsImg2 from "../../../assets/AIpromptEngBenefitsImg2.png";
import AIpromptEngBenefitsImg3 from "../../../assets/AIpromptEngBenefitsImg3.png";
import AIpromptEngBenefitsImg4 from "../../../assets/AIpromptEngBenefitsImg4.png";
import AIpromptEngBenefitsImg5 from "../../../assets/AIpromptEngBenefitsImg5.png";
import AIpromptEngBenefitsImg6 from "../../../assets/AIpromptEngBenefitsImg6.png";
import AIpromptEngBenefitsImg7 from "../../../assets/AIpromptEngBenefitsImg7.png";
import AIpromptEngBenefitsImg8 from "../../../assets/AIpromptEngBenefitsImg8.png";
import AIpromptEngBenefitsImg9 from "../../../assets/AIpromptEngBenefitsImg9.png";
import FunActivities from "../../../MyComponents/FunActivities";
import AIpromptEngFunActivitiesImg1 from "../../../assets/AIpromptEngFunActivitiesImg1.png";
import AIpromptEngFunActivitiesImg2 from "../../../assets/AIpromptEngFunActivitiesImg2.png";
import AIpromptEngFunActivitiesImg3 from "../../../assets/AIpromptEngFunActivitiesImg3.png";
import AIpromptEngFunActivitiesImg4 from "../../../assets/AIpromptEngFunActivitiesImg4.png";
import AIpromptEngFunActivitiesImg5 from "../../../assets/AIpromptEngFunActivitiesImg5.png";
import LearningStyle from "../../../MyComponents/LearningStyle";
import Testimonials from "../../../MyComponents/Testimonials";
import FAQs from "../../../MyComponents/FooterPages/newfaq";

const AIpromptEngineering = () => {
  const AIpromptEngineeringpage = heroContent.AIpromptEngineeringpage;

  const beginnerModules = [
    {
      title: "Module 1",
      activities: "16",
      classes: "8",
      description:
        "Prompt Engineering Basics -Learn to talk to AI better with clear, effective prompts and smarter instructions.",
    },
    {
      title: "Module 2",
      activities: "12",
      classes: "8",
      description:
        " Advanced Prompt Engineering - Master the art of crafting precise prompts and learn how AI understands language to get smarter, clearer responses.",
    },
  ];

  const benefitsData = [
    {
      title: "Master the Basics",
      description: "Learn how prompt engineering works.",
      icon: AIpromptEngBenefitsImg1,
    },
    {
      title: "Create Smart Prompts",
      description: "Design effective prompts for better AI answers.",
      icon: AIpromptEngBenefitsImg2,
    },
    {
      title: "Talk to AI Clearly",
      description: "Communicate with AI for accurate results.",
      icon: AIpromptEngBenefitsImg3,
    },
    {
      title: "Use in Real Life",
      description: "Apply skills in school, creativity & more.",
      icon: AIpromptEngBenefitsImg4,
    },
    {
      title: "Boost AI Accuracy",
      description: "Test and improve prompt quality.",
      icon: AIpromptEngBenefitsImg5,
    },
    {
      title: "Think Ethically",
      description: "Promote kindness and fairness in AI use.",
      icon: AIpromptEngBenefitsImg6,
    },
    {
      title: "Get Creative with AI",
      description: "Use AI for stories, art, and fun ideas.",
      icon: AIpromptEngBenefitsImg7,
    },
    {
      title: "Improve Everyday Tasks",
      description: "Let AI help with writing, planning & projects.",
      icon: AIpromptEngBenefitsImg8,
    },
    {
      title: "Be an AI Pro",
      description: "Build confidence in using AI responsibly.",
      icon: AIpromptEngBenefitsImg9,
    },
  ];
  const activitiesData = [
    {
      title: "Prompt Fixing Challenge",
      image: AIpromptEngFunActivitiesImg1,
    },
    {
      title: "Prompt vs Output Analysis",
      image: AIpromptEngFunActivitiesImg2,
    },
    {
      title: "Clear Prompt Writing",
      image: AIpromptEngFunActivitiesImg3,
    },
    {
      title: "AI Roleplay Exercise",
      image: AIpromptEngFunActivitiesImg4,
    },
    {
      title: "Ethical Prompting Discussion",
      image: AIpromptEngFunActivitiesImg5,
    },
  ];

  return (
    <>
      <GuestNav />
      <Hero2
        titlePart1={AIpromptEngineeringpage.titlePart1}
        description={AIpromptEngineeringpage.description}
        buttonText={AIpromptEngineeringpage.buttonText}
        leftImage={leftimg}
        rightImage={rightimg}
      />
      <CourseTimeline
        title1="Course Structure & Syllabus"
        modules={beginnerModules}
      />
      <Benefits
        title="How Students Can Benefit From AI - Prompt Engineering"
        benefitsData={benefitsData}
      />
      <FunActivities
        mainTitle="Learn AI - Prompt Engineering"
        subTitle="With 30+ Fun Activities"
        activities={activitiesData}
      />
      <LearningStyle />
      <Testimonials />
      <FAQs />
      <Footer />
    </>
  );
};
export default AIpromptEngineering;
